import { render, staticRenderFns } from "./NotificacaoLogDetalhe.vue?vue&type=template&id=365f4d25&scoped=true&"
import script from "./NotificacaoLogDetalhe.vue?vue&type=script&lang=js&"
export * from "./NotificacaoLogDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f4d25",
  null
  
)

export default component.exports